import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';

@Component({
  selector: 'login-forced',
  templateUrl: './login-forced.dialog.html',
  styleUrls: ['./login-forced.dialog.scss'],
})
export class LoginForcedDialog implements OnInit {

  constructor
  (
    private dialogRef                   : MatDialogRef<LoginForcedDialog> ,
    @Inject(MAT_DIALOG_DATA) public data: any                             ,
  ) {}

  ngOnInit(): void
  {
    
  }

  cancell(){
    this.dialogRef.close( 
      {
        code: DialogsReturnCode.LOGIN_FORCED_CANCELL
      }
    )
  }

  async continue(){
    this.dialogRef.close( 
      {
        code: DialogsReturnCode.LOGIN_FORCED_ACCEPT
      }
    )
  }
}
